import { useAppSelector } from '../../../common/hooks/useThunkDispatch';
import { featureFlagsSelectors } from '../../../common/selectors/featureFlagsSelectors';

export const useIsNewEnergyLabelsEnabled = () =>
    useAppSelector((state) =>
        featureFlagsSelectors.selectDynamicFlagEnabled(state, 'EnableNewEnergyLabels'),
    );
